import * as React from "react";
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {PanelDashed} from "../../../../../components/PanelDashed";
import {
    IClaimProperties,
    ICustomerPortalService,
    Image,
    OnlineClaimResponse,
    OnlineRentersClaimRequest,
    Policy,
    PolicyHistory,
    Types,
    ValuableItemWithStartDate,
    FalconNavigatorHeader,
    POLICY_STATUS_MTC,
    SOMETHING_ELSE,
    SOMETHING_WAS_DAMAGED,
    SOMETHING_WAS_LOST,
    SOMETHING_WAS_STOLEN
} from "@falcon/services";
import {lazyInject} from "@athena-portal/core";
import {ClaimItemModal} from "./ClaimItemModal";
import {
    deleteSessionStorage, getAmountToDisplay,
    getSessionStorage,
    scrollToTop,
    setSessionStorage
} from "../../../../../CommonFunctions";
import {ItemsForClaimPanel} from "./ItemsForClaimPanel";
import {v4 as uuid} from "uuid";
import * as moment from "moment";
import {BackButton} from "../../../../../components/navigation/BackButton";
import {TextAreaComponent} from "../../../../../components/inputs/TextAreaComponent";
import {RadioInput} from "../../../../../components/inputs/RadioInput";
import {ClaimDatePicker} from "../../../../../components/claims/ClaimDatePicker";
import {AccidentTimeInput} from "../../../../../components/claims/AccidentTimeInput";

interface IWhenAndWhereClaimPageState {
    onlineRentersClaimRequest: OnlineRentersClaimRequest;
    valuableItems: ValuableItemWithStartDate[];
    whenAndWhere: IWhenAndWhereClaim;
    showOverlay: boolean;
    lossDateValid?: boolean;
    accidentTimeMessage: string;
}

export default interface IWhenAndWhereClaim {
    isAccidentPlaceAwayFromHomeDescriptionValid: boolean;
    isSomethingElseClaimReasonValid: boolean;
    isMoreDetailsDescriptionValid: boolean;
    showAddNewItemModal: boolean;
    policy?:Policy;
    historicPolicy?:Policy;
}

@authorize
export class WhenAndWhereClaimPagePlain extends React.Component<IWithRouterProps, IWhenAndWhereClaimPageState> {

    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IWithRouterProps) {
        super(props);
        const onlineRentersClaimRequestSession: OnlineRentersClaimRequest = getSessionStorage("onlineRentersClaimRequest");
        const valuableItemsSession: ValuableItemWithStartDate[] = getSessionStorage("valuableItems");
        const whenAndWhere: IWhenAndWhereClaim = getSessionStorage("whenAndWhere");
        const rentersClaimSession = getSessionStorage("rentersClaim");

        this.state = {
            onlineRentersClaimRequest: onlineRentersClaimRequestSession !== null ? onlineRentersClaimRequestSession : new OnlineRentersClaimRequest,
            whenAndWhere: whenAndWhere !== null ? whenAndWhere : {
                isAccidentPlaceAwayFromHomeDescriptionValid: true,
                isSomethingElseClaimReasonValid: true,
                isMoreDetailsDescriptionValid: true,
                showAddNewItemModal: false,
                policy: rentersClaimSession.selectedPolicy
            } as IWhenAndWhereClaim,
            valuableItems: valuableItemsSession != null ? valuableItemsSession : [],
            showOverlay: false,
            accidentTimeMessage: "Please answer this to carry on"
        }

        this.setLossDateInputValid = this.setLossDateInputValid.bind(this);
    };

    public componentDidMount(): void {
        scrollToTop();
        this.pluginTemplates.setPageTitle("Your renters claims");

        this.customerPortalService.getValuableItemsWithStartDates().subscribe((valuables: ValuableItemWithStartDate[]) => {
            if (getSessionStorage("valuableItems") === null) {
                this.setState({valuableItems: valuables});
                setSessionStorage("valuableItems", valuables);
            }
        });
    }

    public render() {
        const {onlineRentersClaimRequest, valuableItems, whenAndWhere} = this.state;

        if (valuableItems && whenAndWhere.policy) {
            return (
                <React.Fragment>
                    <FalconHeader/>

                    <div className="page-contents">
                        <FalconNavigatorHeader back="/dashboard/rentersClaims/new" title="When and where?"/>
                        {this.renderWhenAndWherePanel()}
                        {this.showWhyAreYouClaimingPanel() && this.renderWhyAreYouClaimingPanel()}
                        {this.showWhyAreYouClaimingPanel() && onlineRentersClaimRequest.claimingReason &&
                        <ItemsForClaimPanel
                            valuableItems={this.state.valuableItems}
                            onlineRentersClaimRequest={onlineRentersClaimRequest}
                            onOpenModal={this.handleModalToggle}
                            onItemAdding={this.handleCheckBox}
                            onItemDeleting={this.handleItemRemoving}
                            onItemUpdate={this.handleItemUpdate}
                            onImagesAdding={this.handleImageAdding}
                            onImageRemoving={this.handleImageRemoving}
                            onValuableItemRemoving={this.handleValuableItemRemoving}/>}
                        {this.showWhyAreYouClaimingPanel() && whenAndWhere.showAddNewItemModal &&
                        <ClaimItemModal
                            onHide={() => this.handleModalToggle(false)}
                            onItemAdding={this.handleNewItemAdding}
                            showModal={whenAndWhere.showAddNewItemModal}/>}
                        {this.showWhyAreYouClaimingPanel() && onlineRentersClaimRequest.claimingReason &&
                            <>
                                <h1 className="page-heading-black">More details</h1>
                                <div className="section-panel">
                                    <TextAreaComponent
                                        questionLabel={"Give us a short description of what happened. Include the cause of your claim"}
                                        isValid={whenAndWhere.isMoreDetailsDescriptionValid}
                                        onChange={this.handleMoreDetailsOnClaimReasonDescription}
                                        id={"shortDescriptionOfClaim"}
                                        maxLength={300}
                                        value={this.state.onlineRentersClaimRequest.moreDetailsForClaimingReason}
                                        largeTextArea={false}
                                    />
                                </div>
                            </>
                        }
                        {(onlineRentersClaimRequest.claimingReason && this.state.lossDateValid === true) &&
                        <div className="claim-excess-panel bg-white-blue rounded">
                            <img className="d-block cancel-subscription-attention-icon" src="/img/attention_icon_blue.png" alt="warning"/>
                            <div className="font-weight-semi-bold">You’ll have an excess of {whenAndWhere.historicPolicy ?
                                getAmountToDisplay(whenAndWhere.historicPolicy.interaction.factors.excessAmount) : getAmountToDisplay(whenAndWhere.policy.interaction.factors.excessAmount)} to pay</div>
                        </div>}
                        <div className="px-4 px-md-0 ml-md-19">
                            <button type="button"
                                    disabled={!this.isFormValid()}
                                    className="btn btn-primary btn-next plugin"
                                    onClick={this.handleSubmit}
                                    id="submitWhenAndWhere">Next</button>
                        </div>
                        <BackButton isTop={false}/>
                    </div>
                    <Overlay show={this.state.showOverlay}/>
                    <FalconFooter/>
                </React.Fragment>
            )
        } else {
            return (<Overlay show={true}/>)
        }
    }

    private showWhyAreYouClaimingPanel = (): boolean => {
        const {onlineRentersClaimRequest} = this.state;

        const isAccidentPlaceValid: boolean = onlineRentersClaimRequest.claimUrgent !== undefined && onlineRentersClaimRequest.haveVulnerabilities !== undefined &&
            (onlineRentersClaimRequest.accidentPlaceHomeOrNot ||
                (!onlineRentersClaimRequest.accidentPlaceHomeOrNot && onlineRentersClaimRequest.accidentPlaceAwayFromHomeDescription !== undefined));

        return this.state.lossDateValid === true && isAccidentPlaceValid;

    };

    private isFormValid = (): boolean => {
        const {onlineRentersClaimRequest} = this.state;
        const isClaimReasonValid: boolean = (onlineRentersClaimRequest.claimingReason !== undefined && onlineRentersClaimRequest.claimingReason !== "Something else" ||
            (onlineRentersClaimRequest.claimingReason === "Something else" && onlineRentersClaimRequest.claimingReasonDescription !== undefined && onlineRentersClaimRequest.claimingReasonDescription !== ""));
        const itemsForClaimNotEmpty: boolean = onlineRentersClaimRequest.itemsForClaim && onlineRentersClaimRequest.itemsForClaim.length > 0;

        const isAdditionalDetailsValid: boolean = onlineRentersClaimRequest.moreDetailsForClaimingReason !== undefined && onlineRentersClaimRequest.moreDetailsForClaimingReason !== "";

        const isAccidentPlaceValid: boolean = (onlineRentersClaimRequest.accidentPlaceHomeOrNot ||
            (!onlineRentersClaimRequest.accidentPlaceHomeOrNot && onlineRentersClaimRequest.accidentPlaceAwayFromHomeDescription !== undefined
                && onlineRentersClaimRequest.accidentPlaceAwayFromHomeDescription !== ""));

        return this.showWhyAreYouClaimingPanel() && isClaimReasonValid && itemsForClaimNotEmpty && isAdditionalDetailsValid && isAccidentPlaceValid;

    };

    private renderWhenAndWherePanel = (): React.ReactNode => {
        const policy: Policy = this.state.whenAndWhere.policy!;
        const endDate: moment.Moment = moment.utc(policy.endDate, moment.ISO_8601);
        const maxDate: string | null = (policy.status === POLICY_STATUS_MTC && endDate.isBefore(moment())) ? policy.endDate : null;

        return (
            <React.Fragment>
                <div className="section-panel pb-2">
                    <ClaimDatePicker onDateSelect={this.handleAccidentDate}
                        date={this.state.onlineRentersClaimRequest.accidentDate}
                        minDate={this.state.whenAndWhere.policy!.startDate}
                        mtcMaxDate={maxDate}
                    />
                    {Boolean(this.state.onlineRentersClaimRequest.accidentDate) &&
                        <AccidentTimeInput onlineClaimRequest={this.state.onlineRentersClaimRequest}
                            policy={policy}
                            handleAccidentHour={this.handleAccidentHour}
                            handleRadioSelection={this.handlePMorAMCheckBoxes}
                            setInputValidity={this.setLossDateInputValid}
                            futureDateValidationMessage={"You cannot make claim in the future, if you are unsure please call us on 0800 030 4898"}
                            pastDateValidationMessage={"You cannot make claim before your cover started, if you are unsure please call us on 0800 030 4898"}
                            inputValid={this.state.lossDateValid}
                            validationMessage={this.state.accidentTimeMessage}
                    />
                    }
                    <RadioInput label={<label>Where did it happen?</label>}
                        id="accidentAtHome"
                        onChange={this.setAccidentAtHomeOrNot}
                        value={this.state.onlineRentersClaimRequest.accidentPlaceHomeOrNot}
                        inlineDisplay={false}
                        trueAlternativeLabel="At home"
                        falseAlternativeLabel="Away from home"
                    />
                    {this.state.onlineRentersClaimRequest.accidentPlaceHomeOrNot === false &&
                    <PanelDashed>
                        <TextAreaComponent
                            questionLabel="Please tell us where"
                            isValid={this.state.whenAndWhere.isAccidentPlaceAwayFromHomeDescriptionValid}
                            onChange={this.handleAccidentPlaceAwayFromHomeDescription}
                            id="awayFromHomeAccidentDescription"
                            maxLength={300}
                            value={this.state.onlineRentersClaimRequest.accidentPlaceAwayFromHomeDescription}
                            largeTextArea={false}
                        />
                    </PanelDashed>}
                </div>
            </React.Fragment>
        )
    };

    private renderWhyAreYouClaimingPanel = (): React.ReactNode => {
        return (
            <React.Fragment>
                <h1 className="page-heading-black">Why are you claiming?</h1>
                <div className="section-panel pb-2">
                    <div className={`falcon-checkbox form-group checkbox-margin-top-20`}>
                        <label tabIndex={0}>Please tell us <b>what happened to your possessions</b>?</label>
                        {this.renderClaimOptions()}
                    </div>
                </div>
            </React.Fragment>
        )
    };

    private handleSubmit = (event: any): void => {
        if (event.target.disabled) {
            event.preventDefault();
        } else {
            const onlineRentersClaimRequest: OnlineRentersClaimRequest = {...this.state.onlineRentersClaimRequest};
            onlineRentersClaimRequest.claimSubmissionDate = moment().format("YYYY-MM-DD HH:mm");

            this.setState({onlineRentersClaimRequest}, () => {
                this.setState({showOverlay: true});
                this.customerPortalService.createOnlineRentersClaimRequest(this.state.onlineRentersClaimRequest).subscribe((response:OnlineClaimResponse)=>{
                    const rentersClaimSession = getSessionStorage("rentersClaim");
                    rentersClaimSession.claimReference = response.claimReference;
                    setSessionStorage("rentersClaim",rentersClaimSession);
                    this.clearSessionStorage();
                    this.setState({showOverlay: false});
                    this.props.navigate("/dashboard/rentersClaims/whenAndWhere/claimSuccess");
                })
            });
        }
    };

    private clearSessionStorage = (): void => {
        deleteSessionStorage("onlineRentersClaimRequest");
        deleteSessionStorage("valuableItems");
        deleteSessionStorage("whenAndWhere");
    };

    private renderClaimOptions = (): React.ReactNode => {
        const claimOptions: any = [
            {key: 1, value: SOMETHING_WAS_DAMAGED},
            {key: 2, value: SOMETHING_WAS_STOLEN},
            {key: 3, value: SOMETHING_WAS_LOST},
            {key: 4, value: SOMETHING_ELSE}];

        return (
            <React.Fragment>
                <fieldset className="d-block input-group">
                    {claimOptions.map(
                        (option: any) =>
                            <div key={option.key} className="custom-control margin-bottom-20-padding-left-0">
                                <input className="custom-radiobutton cursor-pointer"
                                       type="radio"
                                       name={`option-${option.key}`}
                                       id={`option-${option.key}`}
                                       value={option.value}
                                       onChange={this.handleClaimReason}
                                       checked={option.value === this.state.onlineRentersClaimRequest.claimingReason}
                                />
                                <label id={`option-${option.key}-label`} className="checkbox-label driver-label"
                                       htmlFor={`option-${option.key}`}>{option.value}</label>
                            </div>
                    )}
                </fieldset>
                {this.state.onlineRentersClaimRequest.claimingReason === "Something else" &&
                <div className="form-group pb-2">
                    <label htmlFor="claimReasonDescription">Please describe what happened</label>
                    <textarea className={`form-control description-textarea ${!this.state.whenAndWhere.isSomethingElseClaimReasonValid && "is-invalid"}`} id="claimReasonDescription" maxLength={300}
                    value={this.state.onlineRentersClaimRequest.claimingReasonDescription} onChange={this.handleClaimReasonDescription} onClick={this.handleClaimReasonDescription}/>
                </div>}
            </React.Fragment>
        );
    };

    private handleImageAdding = (itemId: string, images: Image[]): void => {
        const onlineRentersClaimRequest: OnlineRentersClaimRequest = {...this.state.onlineRentersClaimRequest};
        const itemIndex: number = onlineRentersClaimRequest.itemsForClaim.map((item: any) => item.itemId).indexOf(itemId);
        onlineRentersClaimRequest.itemsForClaim[itemIndex].images = [...images];
        this.setState({onlineRentersClaimRequest});
        setSessionStorage("onlineRentersClaimRequest", onlineRentersClaimRequest);
    };

    private handleImageRemoving = (itemId: string, imageId: string): void => {
        const onlineRentersClaimRequest: OnlineRentersClaimRequest = {...this.state.onlineRentersClaimRequest};
        const itemIndex: number = onlineRentersClaimRequest.itemsForClaim.map((item: any) => item.itemId).indexOf(itemId);
        const images: Image[] = onlineRentersClaimRequest.itemsForClaim[itemIndex].images;
        const imageIndex: number = images.map((item: Image) => item.id).indexOf(imageId);
        images.splice(imageIndex, 1);
        onlineRentersClaimRequest.itemsForClaim[itemIndex].images = images;
        this.setState({onlineRentersClaimRequest});
        setSessionStorage("onlineRentersClaimRequest", onlineRentersClaimRequest);
    };

    private handleItemRemoving = (itemId: string): void => {
        const itemsForClaim: any[] = this.state.onlineRentersClaimRequest.itemsForClaim ? this.state.onlineRentersClaimRequest.itemsForClaim : [];
        const onlineRentersClaimRequest: OnlineRentersClaimRequest = {...this.state.onlineRentersClaimRequest};
        const index: number = itemsForClaim.map(item => item.itemId).indexOf(itemId);
        itemsForClaim.splice(index, 1);
        onlineRentersClaimRequest.itemsForClaim = itemsForClaim;
        this.setState({onlineRentersClaimRequest});
        setSessionStorage("onlineRentersClaimRequest", onlineRentersClaimRequest);
    };

    private handleValuableItemRemoving = (itemId: string): void => {
        const itemsForClaim: any[] = this.state.onlineRentersClaimRequest.itemsForClaim ? this.state.onlineRentersClaimRequest.itemsForClaim : [];
        const onlineRentersClaimRequest: OnlineRentersClaimRequest = {...this.state.onlineRentersClaimRequest};
        const valuableItems: ValuableItemWithStartDate[] = this.state.valuableItems;
        const onlineClaimIndex: number = itemsForClaim.map(item => item.itemId).indexOf(itemId);
        const valuableItemIndex: number = valuableItems.map((item: ValuableItemWithStartDate) => item.valuableItemId).indexOf(itemId);
        itemsForClaim.splice(onlineClaimIndex, 1);
        valuableItems.splice(valuableItemIndex, 1);
        onlineRentersClaimRequest.itemsForClaim = itemsForClaim;
        this.setState({onlineRentersClaimRequest, valuableItems});
        setSessionStorage("onlineRentersClaimRequest", onlineRentersClaimRequest);
        setSessionStorage("valuableItems", valuableItems);
    };

    private handleNewItemAdding = (itemsForClaim: IClaimProperties, state: boolean): void => {
        const onlineRentersClaimRequest: OnlineRentersClaimRequest = {...this.state.onlineRentersClaimRequest};
        const whenAndWhere: IWhenAndWhereClaim = {...this.state.whenAndWhere!};
        !onlineRentersClaimRequest.itemsForClaim ? onlineRentersClaimRequest.itemsForClaim = [] : onlineRentersClaimRequest.itemsForClaim;

        const id: string = uuid();
        onlineRentersClaimRequest.itemsForClaim.push({
            type: itemsForClaim.type,
            description: itemsForClaim.description,
            price: itemsForClaim.price,
            claimType: onlineRentersClaimRequest.claimingReason,
            images: itemsForClaim.images!,
            itemId: id
        });

        const valuableItem: ValuableItemWithStartDate = new ValuableItemWithStartDate();
        valuableItem.valuableItemType = {code: itemsForClaim.type, text: ""};
        valuableItem.value = itemsForClaim.price;
        valuableItem.description = itemsForClaim.description;
        valuableItem.valuableItemId = id;
        whenAndWhere.showAddNewItemModal = state;

        this.setState({
            whenAndWhere,
            onlineRentersClaimRequest,
            valuableItems: [...this.state.valuableItems, valuableItem]
        });
        setSessionStorage("valuableItems", [...this.state.valuableItems, valuableItem]);
        setSessionStorage("whenAndWhere", whenAndWhere);
        setSessionStorage("onlineRentersClaimRequest", onlineRentersClaimRequest);
    };

    private handleItemUpdate = (itemForClaim: IClaimProperties): void => {
        const onlineRentersClaimRequest: OnlineRentersClaimRequest = {...this.state.onlineRentersClaimRequest};
        const valuableItems: ValuableItemWithStartDate [] = this.state.valuableItems;
        !onlineRentersClaimRequest.itemsForClaim ? onlineRentersClaimRequest.itemsForClaim = [] : onlineRentersClaimRequest.itemsForClaim;
        const valuableItemIndex: number = valuableItems.map((item: ValuableItemWithStartDate) => item.valuableItemId).indexOf(itemForClaim.itemId!);
        const onlineClaimItemIndex: number = onlineRentersClaimRequest.itemsForClaim.map((item: any) => item.itemId).indexOf(itemForClaim.itemId!);

        const valuableItem: ValuableItemWithStartDate = new ValuableItemWithStartDate();
        valuableItem.valuableItemId = itemForClaim.itemId!;
        valuableItem.description = itemForClaim.description;
        valuableItem.valuableItemType = {code: itemForClaim.type, text: ""};
        valuableItem.value = itemForClaim.price;

        valuableItems[valuableItemIndex] = valuableItem;

        onlineRentersClaimRequest.itemsForClaim[onlineClaimItemIndex] = {
            type: itemForClaim.type,
            description: itemForClaim.description,
            price: itemForClaim.price,
            claimType: onlineRentersClaimRequest.claimingReason,
            itemId: itemForClaim.itemId!,
            images: onlineRentersClaimRequest.itemsForClaim[onlineClaimItemIndex].images ? onlineRentersClaimRequest.itemsForClaim[onlineClaimItemIndex].images : []
        };

        this.setState({onlineRentersClaimRequest, valuableItems});
        setSessionStorage("valuableItems", valuableItems);
        setSessionStorage("onlineRentersClaimRequest", onlineRentersClaimRequest);
    };

    private handleCheckBox = (itemForClaim: IClaimProperties): void => {
        const onlineRentersClaimRequest: OnlineRentersClaimRequest = {...this.state.onlineRentersClaimRequest};

        !onlineRentersClaimRequest.itemsForClaim ? onlineRentersClaimRequest.itemsForClaim = [] : onlineRentersClaimRequest.itemsForClaim;
        onlineRentersClaimRequest.itemsForClaim.push({
            type: itemForClaim.type,
            description: itemForClaim.description,
            price: itemForClaim.price,
            claimType: onlineRentersClaimRequest.claimingReason,
            images: itemForClaim.images!,
            itemId: itemForClaim.itemId!,
            startDate: moment(itemForClaim.startDate!).format("DD/MM/YYYY"),
            specifiedItemId: itemForClaim.specifiedItemId
        });

        this.setState({onlineRentersClaimRequest});
        setSessionStorage("onlineRentersClaimRequest", onlineRentersClaimRequest);
    };

    private setAccidentAtHomeOrNot = (event: any): void => {
        const state: boolean = event.target.value === "true";
        const onlineRentersClaimRequest: OnlineRentersClaimRequest = {...this.state.onlineRentersClaimRequest};
        if (state) {
            onlineRentersClaimRequest.accidentPlaceAwayFromHomeDescription = "";
        }
        onlineRentersClaimRequest.accidentPlaceHomeOrNot = state;
        this.setState({onlineRentersClaimRequest});
        setSessionStorage("onlineRentersClaimRequest", onlineRentersClaimRequest);
    };

    private handleAccidentPlaceAwayFromHomeDescription = (event: any): void => {
        const state: string = event.target.value;
        const onlineRentersClaimRequest: OnlineRentersClaimRequest = {...this.state.onlineRentersClaimRequest};
        const whenAndWhere: IWhenAndWhereClaim = {...this.state.whenAndWhere!};
        onlineRentersClaimRequest.accidentPlaceAwayFromHomeDescription = state;
        whenAndWhere.isAccidentPlaceAwayFromHomeDescriptionValid = state !== "";
        this.setState({onlineRentersClaimRequest, whenAndWhere});
        setSessionStorage("onlineRentersClaimRequest", onlineRentersClaimRequest);
        setSessionStorage("whenAndWhere", whenAndWhere);
    };

    private handleMoreDetailsOnClaimReasonDescription = (event: any): void => {
        const state: string = event.target.value;
        const onlineRentersClaimRequest: OnlineRentersClaimRequest = {...this.state.onlineRentersClaimRequest};
        const whenAndWhere: IWhenAndWhereClaim = {...this.state.whenAndWhere!};
        onlineRentersClaimRequest.moreDetailsForClaimingReason = state;
        whenAndWhere.isMoreDetailsDescriptionValid = state !== "";
        this.setState({onlineRentersClaimRequest, whenAndWhere});
        setSessionStorage("onlineRentersClaimRequest", onlineRentersClaimRequest);
        setSessionStorage("whenAndWhere", whenAndWhere);
    };

    private handleClaimReason = (event: any): void => {
        const state: string = event.target.value;
        const onlineRentersClaimRequest: OnlineRentersClaimRequest = {...this.state.onlineRentersClaimRequest};
        if (onlineRentersClaimRequest.claimingReason && state !== onlineRentersClaimRequest.claimingReason) {
            onlineRentersClaimRequest.itemsForClaim = [];
        }
        onlineRentersClaimRequest.claimingReason = state;
        this.setState({onlineRentersClaimRequest});
        setSessionStorage("onlineRentersClaimRequest", onlineRentersClaimRequest);
    };

    private handleClaimReasonDescription = (event: any): void => {
        const state: string = event.target.value;
        const onlineRentersClaimRequest: OnlineRentersClaimRequest = {...this.state.onlineRentersClaimRequest};
        const whenAndWhere: IWhenAndWhereClaim = {...this.state.whenAndWhere!};
        onlineRentersClaimRequest.claimingReasonDescription = state;
        whenAndWhere.isSomethingElseClaimReasonValid = state !== "";
        this.setState({onlineRentersClaimRequest, whenAndWhere});
        setSessionStorage("onlineRentersClaimRequest", onlineRentersClaimRequest);
        setSessionStorage("whenAndWhere", whenAndWhere);
    };

    private handleAccidentDate = (state: string): void => {
        const onlineRentersClaimRequest: OnlineRentersClaimRequest = {...this.state.onlineRentersClaimRequest};
        onlineRentersClaimRequest.accidentDate = state;
        onlineRentersClaimRequest.accidentHourTime = "";
        onlineRentersClaimRequest.accidentHour = "";
        this.setState({onlineRentersClaimRequest},this.handleLossDate);
        setSessionStorage("onlineRentersClaimRequest", onlineRentersClaimRequest);
    };

    private handleAccidentHour = (event: any): void => {
        event.preventDefault();
        const state: string = event.target.value;
        const onlineRentersClaimRequest: OnlineRentersClaimRequest = {...this.state.onlineRentersClaimRequest};
        const whenAndWhere: IWhenAndWhereClaim = {...this.state.whenAndWhere!};
        onlineRentersClaimRequest.accidentHour = state;
        onlineRentersClaimRequest.accidentHourTime = "";
        this.setState({onlineRentersClaimRequest, whenAndWhere},this.handleLossDate);
        setSessionStorage("onlineRentersClaimRequest", onlineRentersClaimRequest);
        setSessionStorage("whenAndWhere", whenAndWhere);
    };

    private handleModalToggle = (state: boolean): void => {
        const whenAndWhere: IWhenAndWhereClaim = {...this.state.whenAndWhere!};
        whenAndWhere.showAddNewItemModal = state;
        this.setState({whenAndWhere});
        setSessionStorage("whenAndWhere", whenAndWhere);
    };

    private handlePMorAMCheckBoxes = (event: any): void => {
        const onlineRentersClaimRequest: OnlineRentersClaimRequest = this.state.onlineRentersClaimRequest;
        onlineRentersClaimRequest.accidentHourTime = event.target.value;

        this.setState({
            onlineRentersClaimRequest
        } ,this.handleLossDate);

        setSessionStorage("onlineRentersClaimRequest", onlineRentersClaimRequest);
    };

    private handleLossDate = (): void => {
        const whenAndWhere: IWhenAndWhereClaim = {...this.state.whenAndWhere!};
        const {policy} = this.state.whenAndWhere;
        const {onlineRentersClaimRequest} = this.state;
        if (this.state.lossDateValid && policy){
            const claimLossDate = onlineRentersClaimRequest.accidentDate + " " +  onlineRentersClaimRequest.accidentHour + " " + onlineRentersClaimRequest.accidentHourTime;
            const lossDateMoment = moment.utc(claimLossDate,"YYYY-MM-DD hh a");
            const history = policy.policyHistoryList.find((ph: PolicyHistory) => lossDateMoment.isBetween(moment(ph.startDate), moment(ph.endDate), null, "(]"));
            if (history && history.id !== policy.interaction.agreementVersionId){
                this.customerPortalService.getPoliciesByPolicyVersionId(history.id).subscribe((historicPolicy :Policy) => {
                    whenAndWhere.historicPolicy = historicPolicy;
                    this.setState({whenAndWhere});
                    setSessionStorage("whenAndWhere", whenAndWhere);
                });
            } else {
                whenAndWhere.historicPolicy = undefined;
                this.setState({whenAndWhere});
                setSessionStorage("whenAndWhere", whenAndWhere);
            }
        }
    }

    private setLossDateInputValid(lossDateValid: boolean, validationMessage: string): void {
        this.setState({
            lossDateValid,
            accidentTimeMessage: validationMessage
        })
    }
}

export const WhenAndWhereClaimPage = withRouter(WhenAndWhereClaimPagePlain)
